import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5d9b9f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "activate-account-page d-flex align-items-center justify-content-center text-center" }
const _hoisted_2 = { class: "container p-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-1 fs-6" }, "Verify", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_action_button = _resolveComponent("action-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, "Please verify your email address (" + _toDisplayString(_ctx.activationEmail.email) + ")", 1),
      _createVNode(_component_action_button, {
        class: "mx-auto btn-primary-1",
        disabled: _ctx.isActivating,
        onClick: _ctx.handleActivate
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}